import { Grid } from 'components/box';
import { PillVariantsEnum, StockConfig } from 'types/types';
import Label from 'components/_shared/elements/label';
import Pill from 'components/_shared/elements/pill';
import QuantitySelect from 'components/quantity-select';
import config from '../../../../../util/load-config';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import MoreInfo from 'components/_shared/elements/more-info';

const CustomerLimitDisclaimerModal = dynamic(
  () => import('components/_pages/products/modals/customer-limit-disclaimer')
);

const QuantitySelector = ({
  quantity,
  setQuantity,
  xLeftQuantity,
  stockConfig,
  disabled,
}: {
  quantity: number;
  setQuantity: (quantity: number) => void;
  xLeftQuantity?: number | null;
  stockConfig: StockConfig;
  disabled?: boolean;
}) => {
  const [showDisclaimerModal, setShowDisclaimerModal] = useState(false);
  const showCustomerLimitDisclaimer =
    (stockConfig.isMaxSaleQtyApplicableToCustomOptions ||
      stockConfig.isMaxSaleQtyApplicableToCustomerProfile) &&
    stockConfig.maximumSaleQuantity <= config.products.showDisclaimerQty;

  return (
    <>
      <div>
        <Label fontWeight={600} lineHeight={1.5} mb={1}>
          Quantity
        </Label>

        <Grid gridTemplateColumns={xLeftQuantity ? '1fr auto' : '1fr'} mb="7px">
          <QuantitySelect
            onChange={({ target }) => setQuantity(+target.value)}
            quantity={quantity}
            qtyLeft={xLeftQuantity}
            stockConfig={stockConfig}
            selectProps={{ mb: 0, disabled }}
          />

          {xLeftQuantity && (
            <Pill
              variant={PillVariantsEnum.warning}
              alignSelf="center"
            >{`${xLeftQuantity} left`}</Pill>
          )}
        </Grid>

        {showCustomerLimitDisclaimer && (
          <MoreInfo
            label={`Maximum allowed per customer: ${stockConfig.maximumSaleQuantity}`}
            callback={() => setShowDisclaimerModal(true)}
            justifyContent="start"
          />
        )}
      </div>

      {showCustomerLimitDisclaimer && (
        <CustomerLimitDisclaimerModal
          isOpen={showDisclaimerModal}
          close={() => setShowDisclaimerModal(false)}
          description={config.products.customerLimitDisclaimer}
        />
      )}
    </>
  );
};

export default QuantitySelector;
